import { PersonTradeSkillsBus } from './PersonTradeSkillsBus';
import { PersonNotesBus } from './PersonNotesBus';
import { BaseBus } from './BaseBus';
import { EmployHistoryBus } from './EmployHistory';

type Guid = string;

export class PersonBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        if (busObj != null) {

        } else {
            this.birthday = new Date();
            this.dlexpire = new Date();
        }
    }
    personId: Guid;
    companyId: Guid;
    userId: Guid;
    isActive: boolean;
    firstName: string = '';
    middleName: string = '';
    lastName: string = '';
    public get name(): string {
        return this.firstName + ' ' + this.lastName;
    }
    insertDt: Date;
    updateDt: Date;
    contactEmail: string;
    timekey: string;
    empNo: string;
    insertUserId: Guid;
    updateUserId: Guid;
    jobRoleId: Guid;
    baseUnionId: Guid;
    poapprLimit: number = 0;
    epanbr: string;
    hasMobile: boolean;
    termDt: Date;
    mainNumber: string = '';
    cellNumber: string = '';
    jobTitle: string = '';
    trade: number;
    city: string = '';
    state: string = '';
    legalName: string;
    birthday: Date;
    emailPersonal: string;
    costCenter: number = 0;
    i9verified: boolean;
    dlnbr: string;
    dlstate: string;
    dlexpire: Date;
    hasCreditCard: boolean;
    creditCard: string;
    personalPhone: string;
    requireClockInOut: boolean;
    skillRating: number = 0;
    managerId: Guid;
    address1: string = '';
    address2: string;
    zip: string = '';
    photo: string = '';
    companyBranchId: Guid;
    co: number;
    tradeSkills: PersonTradeSkillsBus[];
    notes: PersonNotesBus[];
    jobTitlesId: Guid;
    secJobRoleId: Guid;
    departmentId: Guid;
    sCpin: string;
    onStockReplenishment: boolean;
    employHistory: EmployHistoryBus[];
    covidVaccinationDate: Date;
    covidVaccinationNotVaccinated: boolean;
    covidBoosterDate: Date;
    covidBoosterNotVaccinated: boolean;
    covidSecondVaccinationDate: Date;
    covidVaccinationBrand: string;
    covidSecondVaccinationBrand: string;
    covidBoosterVaccinationBrand: string;
    creditMemoApprLimit: number = 0;

}

